module.exports = __webpack_public_path__ + "static/media/calor.f514ce86.png";